<div class="phone-component">
  <label *ngIf="item">{{item.translation_key|| item.label| translation|translationFromString | transformText
    :item?.text_transform }}</label>

  <div>
    <p-inputgroup class="cc">
      <p-select name="phone-cc" [(ngModel)]="cc" [options]="countryCodes" optionLabel="name" optionValue="value"
        [placeholder]="'country_code'| translation" (onChange)="numberChanged()" [disabled]="disabled||checkDisable()" fluid ngDefaultControl>
      </p-select>
    </p-inputgroup>
  </div>
  <div class="phone-div">
    <div class="form-field area-code">
      <input name="phone-area-code" pInputText [placeholder]="'area_code'| translation" [(ngModel)]="areaCode"
        (ngModelChange)="numberChanged()" [disabled]="disabled||checkDisable()" fluid />
    </div>
    <div class="form-field phone-number">
      <input name="phone-subscriber" pInputText [placeholder]="'phone_number'| translation" [(ngModel)]="subscriberNumber"
        (ngModelChange)="numberChanged()" [disabled]="disabled||checkDisable()" fluid />
    </div>
  </div>

</div>